/** @format */

import React from "react";

type Props = {
  children: JSX.Element[];
};
const CardSection = ({ children }: Props) => {
  return (
    <div className="xl:px-24 md:px-8 px-4">
      <div className="inner-hero-section rounded-[4px] flex lg:flex-row flex-col lg:space-x-10 space-x-0 lg:space-y-0 space-y-10 bg-white py-20 lg:px-10 px-8 mb-20 -mt-16 relative z-10">
        {children}
      </div>
    </div>
  );
};

export default CardSection;
